export default __webpack_public_path__ + "static/media/NL_parcours_1_carte_1.d210ef41.png";